export const ESTADOS_LIST = "ESTADOS_LIST";
export const ESTADOS_SINGLE = "ESTADOS_SINGLE";
export const ESTADOS_LOADING = "ESTADOS_LOADING";
export const ESTADOS_CREATE = "ESTADOS_CREATE";
export const ESTADOS_UPDATE = "ESTADOS_UPDATE";
export const ESTADOS_DELETE = "ESTADOS_DELETE";